
import React, { useState } from 'react';
import { Plus, Users, Home, FileText } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useClickOutside } from '../../hooks/useClickOutside';

interface CalendarDayActionMenuProps {
    onAction: (actionId: string) => void;
}

export const CalendarDayActionMenu: React.FC<CalendarDayActionMenuProps> = ({ onAction }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useClickOutside<HTMLDivElement>(() => setIsOpen(false));

  return (
    <div className="relative z-10" ref={menuRef}>
      <button 
        onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
        }}
        className={`p-1 rounded-full transition-all duration-200 ${isOpen ? 'bg-[#5D1828]/10 text-[#5D1828]' : 'text-[#6B7280] hover:bg-[#F3F4F6] hover:text-[#5D1828] opacity-0 group-hover:opacity-100'}`}
      >
        <Plus size={14} strokeWidth={2.5} className={isOpen ? 'rotate-45 transition-transform' : 'transition-transform'} />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 5 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 5 }}
            className="absolute right-0 top-full mt-1 bg-white rounded-xl shadow-lg border border-[#D1D5DB] p-1 flex flex-col gap-1 w-32 z-50"
            onClick={(e) => e.stopPropagation()}
          >
            <button 
                onClick={() => { onAction('reunion'); setIsOpen(false); }}
                className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-[#5D1828]/10 text-[#6B7280] hover:text-[#5D1828] text-xs font-medium transition-colors"
            >
                <Users size={14} />
                Reunión
            </button>
            <button 
                onClick={() => { onAction('propuesta'); setIsOpen(false); }}
                className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-[#B89658]/10 text-[#6B7280] hover:text-[#B89658] text-xs font-medium transition-colors"
            >
                <Home size={14} />
                Propuesta
            </button>
            <button 
                onClick={() => { onAction('gestion'); setIsOpen(false); }}
                className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-[#B89658]/10 text-[#6B7280] hover:text-[#B89658] text-xs font-medium transition-colors"
            >
                <FileText size={14} />
                Gestión
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};